export enum ResourceTypeStaleTimeEnum {
  GetAll = 60000,
}
